import {computed} from "vue";

/**
 * StaticTooltip 封裝
 */
export const useStaticTooltip = (
   props) => {

    /**
     * 是否套用 StaticTooltip 顯示 錯誤
     */
    const isStaticTooltip = computed(() => {
        return props.active !== undefined && props.prefix !== undefined
    })

    return {
        isStaticTooltip
    }

}
